export class BookingConfirmationTemplate {

    constructor(
        public id: number,
        public name: string
    ){}
}
